import { getMobileAndDesktopFirstImage } from 'components/PageSections/utils';

import { TakeoverPromoSectionProps } from './TakeoverPromoSection';

export const parseTakeoverPromoHomepage = (
  section: Queries.ContentfulSection001,
): TakeoverPromoSectionProps => {
  const { subsections, metadata } = section || [];

  const mainSubsection = subsections?.[0] as Queries.ContentfulSection001;
  const secondarySubsection = subsections?.[1] as Queries.ContentfulSection001;

  const secondaryCard = secondarySubsection
    ? {
        ...getMobileAndDesktopFirstImage(secondarySubsection.images),
        cta: {
          displayName: undefined,
          label: secondarySubsection?.metadata?.ctas?.[0]?.label ?? '',
          url: secondarySubsection?.metadata?.ctas?.[0]?.url ?? '',
        },
      }
    : undefined;

  return {
    heading: metadata?.title ?? '',
    description: metadata?.description?.description ?? '',
    primaryCard: {
      ...getMobileAndDesktopFirstImage(mainSubsection.images),
      heading: mainSubsection?.metadata?.title ?? '',
      description: mainSubsection?.metadata?.description?.description ?? '',
      backgroundColor: mainSubsection?.metadata?.theme?.backgroundColor,
      cta: {
        displayName: undefined,
        label: mainSubsection?.metadata?.ctas?.[0]?.label ?? '',
        url: mainSubsection?.metadata?.ctas?.[0]?.url ?? '',
      },
    },
    secondaryCard,
  };
};
